<template>
  <div class="main-container">
    <div class="left">
      <slot name="left"></slot>
    </div>
    <div class="right">
      <slot name="right"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "tsl-container"
};
</script>
<style scoped lang="less">
.main-container {
  display: flex;
  width: 100%;
  .left {
    box-sizing: border-box;
    width: 72%;
    padding-right: 16px;
  }
  .right {
    width: 28%;
  }
}
</style>
